module.exports = __webpack_public_path__ + "assets/img/IMG036.6b710c89.png";